import { useEffect, useRef } from "react";

const escapeHandlers: Array<() => void> = [];

const handleEscape = (event: KeyboardEvent) => {
  if (event.key !== "Escape" || event.repeat) return;

  const closeTopmostModal = escapeHandlers[escapeHandlers.length - 1];
  if (!closeTopmostModal) return;

  event.preventDefault();
  event.stopPropagation();
  closeTopmostModal();
};

const useCloseOnEscape = (isOpen: boolean, onClose: () => void) => {
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return;

    const closeModal = () => onCloseRef.current();
    escapeHandlers.push(closeModal);

    if (escapeHandlers.length === 1) {
      window.addEventListener("keydown", handleEscape);
    }

    return () => {
      const handlerIndex = escapeHandlers.lastIndexOf(closeModal);
      if (handlerIndex >= 0) escapeHandlers.splice(handlerIndex, 1);

      if (escapeHandlers.length === 0) {
        window.removeEventListener("keydown", handleEscape);
      }
    };
  }, [isOpen]);
};

export default useCloseOnEscape;
